
function recaptcha_v3_callback(token) {
    // Does element exist
    if($('#g-recaptcha-token').length){
        $('#g-recaptcha-token').val(token);
    }
    else {
        var input = document.createElement("input");
        input.setAttribute("type", "hidden");
        input.setAttribute("name", "g-recaptcha-token");
        input.setAttribute("id", "g-recaptcha-token");
        input.setAttribute("value", token);
        if ($('form').length > 0 ) {
            $('form').append(input);
        }
    }

    setTimeout(recaptcha_v3_execute, 10000);
}

function recaptcha_v3_execute() {
    grecaptcha.ready(function () {
        grecaptcha.execute(page_info['RECAPTCHA_V3_SITE_KEY'], {action: page_info['template']}).then(recaptcha_v3_callback);
    });
}

if (page_info.trigger_recaptcha_v3) {
    recaptcha_v3_execute();
}
